export type ReadingTopic =
  | "general"
  | "personality"
  | "relationships"
  | "work"
  | "spirituality";

export type CardReadingContext = Exclude<ReadingTopic, "general">;

export interface ReadingContext {
  topic: ReadingTopic;
  question?: string;
}

export const DEFAULT_READING_CONTEXT: ReadingContext = {
  topic: "general",
};

export type ReadingSectionSource =
  | { type: "keywords" }
  | { type: "psychology" }
  | { type: "archetype" }
  | { type: "readingTips" }
  | { type: "selfQuestions" }
  | {
      type: "upright";
      context: CardReadingContext;
    }
  | { type: "uprightByQuestionContext" };

export interface ReadingSectionDefinition {
  id: string;
  title: string;
  source: ReadingSectionSource;
}

export interface PositionReadingProfileOverride {
  sections: ReadingSectionDefinition[];
}

export interface SpreadReadingProfile {
  spreadId: string;
  sections: ReadingSectionDefinition[];
  positionOverrides?: Record<string, PositionReadingProfileOverride>;
}

export interface ReadingSection {
  id: string;
  title: string;
  value: string | string[];
}

export interface PositionReading {
  positionId: string;
  positionTitle: string;
  positionMeaning: string;

  cardId: string;
  cardName: string;
  cardNameEn?: string;

  sections: ReadingSection[];
}


